import React from 'react'

const STORAGE_KEY = 'theme'

function getThemeFromDom() {
  if (typeof document === 'undefined') return 'dark'
  const t = document.documentElement.getAttribute('data-theme')
  return t === 'light' || t === 'dark' ? t : 'dark'
}

function setTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme)
  try {
    window.localStorage.setItem(STORAGE_KEY, theme)
  } catch (e) {
    /* ignore */
  }
}

/** Sun icon — shown when site is dark (click → light mode). White circle style via CSS. */
function IconSun() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  )
}

/** Moon icon — shown when site is light (click → dark mode). Dark circle style via CSS. */
function IconMoon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  )
}

export default class ThemeToggle extends React.Component {
  constructor(props) {
    super(props)
    this.state = { theme: 'dark' }
    this.toggle = this.toggle.bind(this)
  }

  componentDidMount() {
    this.setState({ theme: getThemeFromDom() })
  }

  toggle() {
    const next = this.state.theme === 'dark' ? 'light' : 'dark'
    setTheme(next)
    this.setState({ theme: next })
  }

  render() {
    const { theme } = this.state
    const isDark = theme === 'dark'
    const label = isDark ? 'Switch to light mode' : 'Switch to dark mode'

    return (
      <button
        type="button"
        className={`theme-toggle ${isDark ? 'theme-toggle--show-sun' : 'theme-toggle--show-moon'}`}
        onClick={this.toggle}
        aria-label={label}
        aria-pressed={!isDark}
      >
        {isDark ? <IconSun /> : <IconMoon />}
      </button>
    )
  }
}

export { setTheme, getThemeFromDom, STORAGE_KEY }
